export enum RazorpayTransactionStatesEnum {
    INITIATED = "INITIATED",
    PENDING='PENDING',
    COMPLETED = 'COMPLETED',
    FAILED = 'FAILED',
    REFUNDED = 'REFUNDED'
}